import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AreaSeriesService } from '@syncfusion/ej2-angular-charts';
import { FilteringEventArgs } from '@syncfusion/ej2-angular-dropdowns';
import {
  EditSettingsModel,
  GridComponent,
  GroupSettingsModel,
  QueryCellInfoEventArgs,
  ToolbarItems,
} from '@syncfusion/ej2-angular-grids';
import { Uploader, UploaderComponent } from '@syncfusion/ej2-angular-inputs';
import { Dialog, DialogComponent } from '@syncfusion/ej2-angular-popups';
import {
  DataSourceChangedEventArgs,
  getFormatFromType,
  NumberFormatType,
  SpreadsheetComponent,
} from '@syncfusion/ej2-angular-spreadsheet';
import { constants } from 'os';
import { UnsubscribeOnDestroyAdapter } from 'src/app/core/destroyAdapter/unsubscribe-on-destroy-adapter';
import {
  AdminGeneratedService,
  AvaiablePartnerAgreementsReq,
  CustomerFileUploadDTO,
  CustomerFileUploadReq,
  FileUploadDetailRes,
} from 'src/app/core/services/AdminService/admin-service-generate';
import { ToastService } from 'src/app/core/services/toast.service';
import * as XLSX from 'xlsx';

export let data: Object[] = [
  {
    VKN_TCKN: 1234567890,
    Firma_Ünvan: 'Örnek Firma A.Ş.',
    Telefon: '5550000000',
    Mail: 'ornek@example.com',
    Ülke: 'Türkiye',
    Şehir: 'İstanbul',
    İlçe: 'Kadıköy',
  },
];

@Component({
  selector: 'app-customer-bulk-excel-structure-dialog',
  templateUrl: './customer-bulk-excel-structure-dialog.component.html',
  styleUrls: ['./customer-bulk-excel-structure-dialog.component.css'],
})
export class CustomerBulkExcelStructureDialogComponent
  extends UnsubscribeOnDestroyAdapter
  implements OnInit
{
  public dropElement: HTMLElement = document.getElementsByClassName(
    'control-fluid'
  )[0] as HTMLElement;
  @ViewChild('toast') toast: ElementRef;
  @ViewChild('defaultupload')
  public uploadObj: UploaderComponent;
  @ViewChild('grid')
  public gridObj: GridComponent;

  @ViewChild('grdresult') public grdresult: GridComponent;
  isServiceDefinition: boolean = false; //hızmet tanımı
  isAgreementDefinition: boolean = false; //sozlesme tanımı ve kontor tanımı yapmak ıcın
  isContourDefinition: boolean = false; //kontor tanımı
  public CustomerDataList: CustomerFileUploadDTO[];
  public groupOptions: GroupSettingsModel;
  ErrorDataList: FileUploadDetailRes[];
  public resizeSettings = { mode: 'Auto' };
  public dialog: Dialog;
  public data: object[];
  countryData = [];
  public fields: Object = {
    text: 'Title',
    value: 'Identity',
  };
  cityData = [];
  citySubdivisionData = [];
  countryPlaceHolder = 'Ülke Seçiniz';
  cityPlaceHolder = 'Şehir Seçiniz';
  citySubdivisionPlaceHolder = 'İlçe Seçiniz';
  countryValue: any;
  cityValue: any;
  public editSettings: EditSettingsModel;
  public toolbar: ToolbarItems[];
  public pageSettings: Object;
  citySubdivisionValue: any;
  countryName: string = null;
  public isKeyPressed = false;
  public isCellSave = false;

  agreementCodeData = [];
  localPartnerId: string = null;
  agreementCode = null;

  cityName: string = null;
  isErrorServer = false;
  isFileUploadCompleted = true;
  isMatDialogActionsOpen = false;
  citySubdivisionName: string = null;
  accountingFormat = getFormatFromType(<NumberFormatType>'Accounting');
  @ViewChild('spreadsheet') public spreadsheetObj: SpreadsheetComponent;
  constructor(
    private adminGenerateService: AdminGeneratedService,
    public dialogRef: MatDialogRef<DialogComponent>,
    private toastService: ToastService
  ) {
    super();
  }

  ngOnInit(): void {
    // this.getCountry();
    // this.data = data;
    this.groupOptions = { columns: ['customerId'] };
    this.editSettings = {
      allowEditing: true,
      allowAdding: true,
      allowDeleting: true,
      mode: 'Batch',
    };
    this.toolbar = ['Add', 'Delete', 'Update', 'Cancel'];
    this.pageSettings = { pageCount: 5 };
  }

  public onFileRemove(args): void {
    args.cancel = true;
  }

  dataBound(args: any) {
    (this.gridObj.columns[1] as any).isPrimaryKey = 'true';
    this.gridObj.autoFitColumns([]);
  }

  dataBoundResult() {
    this.grdresult.autoFitColumns([]);
  }

  public onSuccess(args: any): void {
    var files = args.target.files; // FileList object
    this.parseExcel(files[0]);
    this.isFileUploadCompleted = false;
    this.isMatDialogActionsOpen = true;
  }

  onIsServiceDefinitionChange(event) {
    this.isServiceDefinition = event.checked;
  }

  onIsAgreementDefinitionChange(event) {
    this.isAgreementDefinition = event.checked;

    this.getAgreementCodeList(null, this.localPartnerId);
  }

  onIsContourDefinitionChange(event) {
    this.isContourDefinition = event.checked;
  }

  agreementCodeChange(val) {
    this.agreementCode = val.itemData;
  }

  onFilteringAgreementCode(val: FilteringEventArgs) {
    if (val.text.length < 2) {
      return;
    }
    this.getAgreementCodeList(val.text);
    val.updateData(this.agreementCodeData);
  }

  getAgreementCodeList(query?, partnerId?, initialasePartner?: boolean) {
    this.agreementCodeData = [];
    const req = new AvaiablePartnerAgreementsReq({
      filter: query,
      partnerId: this.localPartnerId.toString(), //customiseCell() de set edılıyor.
    });
    this.subs.add(
      this.adminGenerateService.avaiablePartnerAgreementsAll(req).subscribe(
        (res) => {
          console.log(res, 'partnerAgreement');
          this.agreementCodeData = res.map((res) => ({
            Identity: res.id,
            Title: res.code,
            data: res,
          }));
        },
        (err) => {}
      )
    );
  }

  customiseCell(args: QueryCellInfoEventArgs) {
    if (args.column.field === 'Firma_VKN_TCKN') {
      if (args.data['Firma_VKN_TCKN'].toString().length > 11) {
        (args.cell as any).style.backgroundColor = 'red';
      }
    }

    if (
      args.column.field === 'Hizmet_Tanımı' &&
      (args.data['Hizmet_Tanımı'] == 'efatura' ||
        args.data['Hizmet_Tanımı'] == 'eirsaliye')
    ) {
      let splitDataPK = args.data['PK']?.split('@')[1];
      let splitDataGB = args.data['GB']?.split('@')[1];

      if (
        args.data['PK'] == null ||
        args.data['PK'] == undefined ||
        args.data['PK'] == '' ||
        !splitDataPK
      ) {
        // (args.cell as any).style.backgroundColor = 'red';
        args.data['PK'] =
          'urn:mail:defaultpk@' +
          (args.data['Firma_Ünvan'] != undefined
            ? args.data['Firma_Ünvan']
                .replace(/\s/g, '')
                .toLowerCase()
                .substring(0, 5) + '.com.tr'
            : (args.data['Firma_Adı'] + args.data['Firma_Soyadı'])
                .replace(/\s/g, '')
                .toLowerCase()
                .substring(0, 5) + '.com.tr');
      }

      if (
        args.data['GB'] == null ||
        args.data['GB'] == undefined ||
        args.data['GB'] == '' ||
        !splitDataGB
      ) {
        // (args.cell as any).style.backgroundColor = 'red';
        args.data['GB'] =
          'urn:mail:defaultgb@' +
          (args.data['Firma_Ünvan'] != undefined
            ? args.data['Firma_Ünvan']
                .replace(/\s/g, '')
                .toLowerCase()
                .substring(0, 5) + '.com.tr'
            : (args.data['Firma_Adı'] + args.data['Firma_Soyadı'])
                .replace(/\s/g, '')
                .toLowerCase()
                .substring(0, 5) + '.com.tr');
      }
    }

    this.localPartnerId = args.data['Partner_VKN'];

    if (args.column.field === 'Partner_VKN') {
      if (args.data['Partner_VKN'].toString().length > 11) {
        (args.cell as any).style.backgroundColor = 'red';
      }
    }

    if (args.column.field === 'Ülke') {
      if (args.data['Ülke'] == null) {
        (args.cell as any).style.backgroundColor = 'red';
      }
    }

    if (args.column.field === 'Şehir') {
      if (args.data['Şehir'] == null) {
        (args.cell as any).style.backgroundColor = 'red';
      }
    }

    if (args.column.field === 'İlçe') {
      if (args.data['İlçe'] == null) {
        (args.cell as any).style.backgroundColor = 'red';
      }
    }

    if (args.column.field === 'Vergi_Dairesi') {
      if (args.data['Vergi_Dairesi'] == null) {
        (args.cell as any).style.backgroundColor = 'red';
      }
    }

    if (args.column.field === 'İletişim_Ad') {
      if (args.data['İletişim_Ad'] == null) {
        (args.cell as any).style.backgroundColor = 'red';
      }
    }

    if (args.column.field === 'İletişim_Soyad') {
      if (args.data['İletişim_Soyad'] == null) {
        (args.cell as any).style.backgroundColor = 'red';
      }
    }

    if (args.column.field === 'İletişim_Telefon') {
      if (args.data['İletişim_Telefon'] == null) {
        (args.cell as any).style.backgroundColor = 'red';
      }
    }

    if (args.column.field === 'İletişim_Email') {
      if (args.data['İletişim_Email'] == null) {
        (args.cell as any).style.backgroundColor = 'red';
      }
    }
  }

  importFile(e) {
    this.dialog.show();
  }

  click() {
    console.log(this.gridObj.dataSource);
  }

  celsave(args) {
    this.gridObj.editSettings.showConfirmDialog = false;
    this.gridObj.editModule.batchSave();
    this.isCellSave = true;
  }

  celsaved(args) {
    if (this.isKeyPressed && this.isCellSave) {
      this.gridObj.editModule.batchSave();
      args.cancel = true;
    } else {
      this.isKeyPressed = false;
    }
  }

  parseExcel(file) {
    var reader = new FileReader();
    reader.onload = (e) => {
      var data = (<any>e.target).result;
      var workbook = XLSX.read(data, {
        type: 'binary',
      });
      workbook.SheetNames.forEach(
        function (sheetName) {
          // Here is your object

          var XL_row_object = XLSX.utils.sheet_to_json(
            workbook.Sheets[sheetName]
          );
          var json_object = JSON.stringify(XL_row_object);
          console.log(json_object);
          this.gridObj.dataSource = JSON.parse(json_object);
          this.uploadObj.clearAll();
        }.bind(this),
        this
      );
    };

    reader.onerror = function (ex) {
      console.log(ex);
    };
    reader.readAsBinaryString(file);
  }

  onConfirmClick(): void {
    const req = new CustomerFileUploadReq();
    let fileUpload: CustomerFileUploadDTO[] = [];
    var xxx = JSON.stringify(this.gridObj.dataSource);
    var yyy = JSON.parse(xxx);

    yyy.forEach((element) => {
      fileUpload.push(
        new CustomerFileUploadDTO({
          adres_Satırı: element.Adres_Satırı?.toString(),
          bina_Adı: element.Bina_Adı?.toString(),
          daire_No: element.Daire_No?.toString(),
          bina_No: element.Bina_No?.toString(),
          email: element.Email?.toString(),
          fax: element.Fax?.toString(),
          firma_VKN_TCKN: element.Firma_VKN_TCKN?.toString(),
          firma_Ünvan: element.Firma_Ünvan
            ? element.Firma_Ünvan?.toString()
            : element.Firma_Adı?.toString() +
              ' ' +
              element.Firma_Soyadı?.toString(),
          firma_Adı: element.Firma_Adı?.toString(),
          firma_Soyadı: element.Firma_Soyadı?.toString(),
          kısa_Kod: element.Kısa_Kod?.toString(),
          mersis_No: element.Mersis_No?.toString(),
          partner_VKN: element.Partner_VKN?.toString(),
          posta_No: element.Posta_No?.toString(),
          telefon: element.Telefon?.toString(),
          ticaret_Sicil_No: element.Ticaret_Sicil_No?.toString(),
          vergi_Dairesi: element.Vergi_Dairesi?.toString(),
          web_Site: element.Web_Site?.toString(),
          ülke: element.Ülke?.toString(),
          İletişim_Ad: element.İletişim_Ad?.toString(),
          İletişim_Email: element.İletişim_Email?.toString(),
          İletişim_Soyad: element.İletişim_Soyad?.toString(),
          İletişim_Telefon: element.İletişim_Telefon?.toString(),
          İlçe: element.İlçe?.toString(),
          şehir: element.Şehir?.toString(),
          aktivasyon_Tarihi: element.Aktivasyon_Tarihi?.toString(),
          hizmet_Tanımı: element.Hizmet_Tanımı?.toString(),
          partner_Sözleşme_Kodu: element.Partner_Sözleşme_Kodu?.toString(),
          gb: element.GB?.toString(),
          pk: element.PK?.toString(),
        })
      );
    });

    req.fileUpload = fileUpload;
    req.isAgreementDefinition = this.isAgreementDefinition;
    req.isContourDefinition = this.isContourDefinition;
    req.isServiceDefinition = this.isServiceDefinition;
    req.partnerAgreementCode = this.agreementCode?.Identity.toString();
    this.adminGenerateService.customerFileUpload(req).subscribe(
      (res) => {
        if (res.isAdded && res.fileUploadDetailRes.length == 0) {
          this.toastService.showSuccessToast(this.toast.nativeElement, {
            title: 'Toplu Firma Yükleme',
            content: 'İşleminiz Başarıyla Tamamlanmıştır',
          });
          this.dialogRef.close(true);
        } else if (res.isAdded && res.fileUploadDetailRes.length != 0) {
          this.isErrorServer = true;
          this.ErrorDataList = res.fileUploadDetailRes;
        } else {
          // this.isErrorServer = true;
        }
      },
      (err) => {
        this.isErrorServer = true;

        const message = JSON.parse(err.response);
        this.ErrorDataList = message.fileUploadDetailRes;
      }
    );
  }

  keyPressed(args) {
    this.isKeyPressed = args.key == 'Enter';
  }

  changed(args: DataSourceChangedEventArgs) {}

  created() {
    this.spreadsheetObj.cellFormat(
      {
        fontWeight: 'bold',
        fontSize: '12pt',
        backgroundColor: '#279377',
        textAlign: 'center',
        color: '#ffffff',
        borderBottom: '1px solid #e0e0e0',
      },
      'A1:G1'
    );
    // this.spreadsheetObj.cellFormat({ borderTop: '1px solid #e0e0e0', backgroundColor: '#EEEEEE' }, 'A11:F11');
    // this.spreadsheetObj.setBorder({ border: '1px solid #e0e0e0' }, 'A2:F11', 'Outer');
    // Applied Accounting format to the cells from C3 to E10 range.
    // this.spreadsheetObj.numberFormat('_($* #,##0.00_);_($* (#,##0.00);_($* "-"??_);_(@_)', 'C3:E10');
    // Applied Percentage format to the cells from C3 to E11 range.
    // this.spreadsheetObj.numberFormat('0%', 'F3:F10');
  }

  onActionBegin(e) {}

  dataSourceChanged(args: DataSourceChangedEventArgs) {}

  beforeSave(e) {}

  csv(): void {
    console.log(this.spreadsheetObj.sheets[0].ranges[0].dataSource);

    // this.spreadsheetObj.save({ url: 'https://ej2services.syncfusion.com/production/web-services/api/spreadsheet/save', fileName: "Sample", saveType: "Csv" });
    this.spreadsheetObj.save({ fileName: 'Deneme', saveType: 'Xlsx' });
  }
}
